
console.log(process.env.REACT_APP_SERVER_URL, process.env.REACT_APP_CLIENT_URL);

export default {
    SERVER_URL: process.env.REACT_APP_SERVER_URL || 'http://localhost:5000',
    // CLIENT_URL: process.env.REACT_APP_CLIENT_URL || 'http://localhost:3000',
}